import { OptroImportProgressCard } from "./OptroImportProgressCard";
import { useOptroImport } from "../contexts/optroImportContext";
import { useOptroImportInterest } from "../hooks/useOptroImportInterest";

// The controls import's progress card. It keeps the tracker polling while it
// is on screen.
export const OptroImportProgressPanel = () => {
  const {
    activeJob,
    panelVisible,
    dismissImport,
    pollingFailed,
    retryPolling,
    registerInterest,
  } = useOptroImport();
  useOptroImportInterest(panelVisible ? registerInterest : undefined);
  return (
    <OptroImportProgressCard
      activeJob={activeJob}
      panelVisible={panelVisible}
      pollingFailed={pollingFailed}
      onRetry={retryPolling}
      onDismiss={dismissImport}
      noun="controls"
      noWorkpaperLabel="No Workpaper"
      showWorkpaperBreakdown
    />
  );
};
